<script setup lang="ts">
import { ref, computed } from "vue";
import { onClickOutside } from "@vueuse/core";

import type { UrlAlias } from "@Modules/urls/Data/Models/UrlAliasFactory";

//
// Props
interface Props {
    urlAlias: UrlAlias;
    confirmed: () => void;
}

const props = defineProps<Props>();

//
// Emit
interface Events {
    (e: "close"): void;
}

const emit = defineEmits<Events>();

//
// Data
const modalRef = ref<HTMLElement | null>(null);

onClickOutside(modalRef, () => {
    close();
});

//
// Computed
const alias = computed(() => props.urlAlias.mainAlias());
const aliasDisplay = computed(() => alias.value ? `${alias.value.domain}/${alias.value.alias}` : "");

//
// Methods
function close() {
    emit("close");
}

function confirm() {
    props.confirmed();
    emit("close");
}
</script>

<template>
  <div class="modal d-block">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div
        ref="modalRef"
        class="modal-content"
      >
        <div class="flex-center-between pt-4 pr-4 pb-2 pl-4">
          <h6 class="mb-0">
            Archive TinyURL
          </h6>
          <button
            type="button"
            class="_close_modal close-2"
            @click="close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body px-4 text-center text-break">
          <p class="mb-1 font-weight-semibold _alias_name">
            Are you sure you want to archive "{{ aliasDisplay }}"?
          </p>
          <span class="text-gray-500">
            Archiving a TinyURL removes it from your URLs list and won't be shown in combined analytics.
          </span>
        </div>
        <div class="flex-center-center flex-wrap px-4 pb-4">
          <button
            type="button"
            class="_cancel btn btn-block--xs-only rounded-xl px-3 px-md-4 px-lg-5 m-1 btn-outline-blue"
            @click="close"
          >
            No, Go Back
          </button>
          <button
            type="button"
            class="_confirm btn btn-block--xs-only rounded-xl px-3 px-md-4 px-lg-5 m-1 btn-danger"
            @click="confirm"
          >
            Archive TinyURL
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
